import ContentLoader from 'react-content-loader';
import *as React from 'react';

export const CardListingMobileLoader= props=>{
        return(<>
            {props.count && props.count > 0 && (
                          Array.from({ length: props.count }, (_, i) => (
                            <ContentLoader 
                            key={i+1}
                            speed={2}
                            width={1000}
                            height={600}
                            viewBox="0 0 1000 600"
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                           >
                           <rect x="42" y="10" rx="15" ry="15" width="918" height="560" />
                           </ContentLoader>
                          ))
                      )}</>)
      
    }